import axios from 'axios'

// 创建axios的对象
const instance = axios.create({
  baseURL: "https://dajiangapi.sumshu.com",  //配置固定域名
  timeout: 30000
})

// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
// 响应拦截


// 封装get和post请求
export function get (url, params) {
  return instance.get(url, { params })
}

export function post (url, data) {
  return instance.post(url, data)
}

export default instance;